/**
 * Shared utility for rendering text that may contain HTML (from Moodle imports).
 * Used by players that render item.text / question strings directly instead of
 * going through BlockRenderer.
 */

import * as React from 'react';

const HTML_TAG_RE = /<[a-zA-Z][^>]*>/;

/**
 * Render a string that may contain HTML tags.
 * If HTML is detected, renders via dangerouslySetInnerHTML.
 * Otherwise renders as plain text.
 */
export function RichTextInline({
    text,
    className,
    as: Tag = 'span',
}: {
    text: string;
    className?: string;
    as?: 'span' | 'div' | 'p';
}): React.ReactElement | null {
    if (!text) return null;

    if (HTML_TAG_RE.test(text)) {
        return React.createElement(Tag, {
            className: className
                ? `${className} rich-text-inline [&>p]:m-0 [&>p:last-child]:mb-0`
                : 'rich-text-inline [&>p]:m-0 [&>p:last-child]:mb-0',
            dangerouslySetInnerHTML: { __html: text },
        });
    }

    return React.createElement(Tag, { className }, text);
}
